import { render, staticRenderFns } from "./popup-add.vue?vue&type=template&id=1c1bcba8&scoped=true"
import script from "./popup-add.vue?vue&type=script&lang=js"
export * from "./popup-add.vue?vue&type=script&lang=js"
import style0 from "./popup-add.vue?vue&type=style&index=0&id=1c1bcba8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1bcba8",
  null
  
)

export default component.exports